import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { AppConfigProvider } from '../../../app-config.provider';

@Injectable({ providedIn: 'root' })
export class RolesFactory {
  private readonly baseUrl: string;

  constructor(private readonly httpClient: HttpClient, private readonly appConfigProvider: AppConfigProvider) {
    this.baseUrl = appConfigProvider.getRolesPathUrl();

  }
  getRoleService(): RolesService {
    return new RolesService(this.httpClient, this.baseUrl);
  }
}
